import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";


function GenerateReportButton({ onClick, disabled, loading }) {
  return (
    <Button
      variant="contained"
      className="client-notice-btn"
      onClick={onClick}
      disabled={disabled}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <FileDownloadOutlinedIcon />}
    >
      {loading ? 'Generating...' : 'Client Notice Report'}
    </Button>
  );
}

export default GenerateReportButton; 